var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time-limited-image"},[(_vm.isImageVisible && !_vm.rightAngle)?_c('img',{staticClass:"target-image",attrs:{"src":_vm.image,"alt":"限时展示图片"}}):_vm._e(),(_vm.isImageVisible && _vm.rightAngle)?_c('img',{staticClass:"rightAngle",attrs:{"src":_vm.image,"alt":"限时展示图片"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }